export default __webpack_public_path__ + "static/media/2.eb471060.png";